import { ReferralResponse } from '../models/Referral';
import api from './index';

const getReferral = async () => {
  const { data } = await api.get<ReferralResponse>(`/v4/referral`);
  return data;
};

export const ReferralService = {
  getReferral,
};
